import { Loader } from "@hawkins/components";
import '@hawkins/components/lib/css/styles.css';

import classes from "./LoadingOverlay.module.css";

interface LoadingOverlayProps {
  size?: number;
  isLoading?: boolean;
  children?: React.ReactNode;
};

export const LoadingOverlay = ({ size = 60, isLoading = true, children }: LoadingOverlayProps) => {

  return (
    <>
      {children}
      {isLoading && (
        <div className={classes.container}>
          <div className={classes.wrapper} data-testid="loading-overlay">
            <Loader size={size} />
          </div>
        </div>)}
    </>
  );
};
